import './style.scss'
import { AppSpan, AppText, Circle, CustomContainer, FlexRow, GridContainer } from 'src/style'
import { BsChatLeft, BsTelephone, BsThreeDotsVertical } from 'react-icons/bs'
import { HiOutlineChevronDown, HiOutlinePlay } from 'react-icons/hi'
import { IoPlayOutline } from 'react-icons/io5'
import helpers from '../helpers'
import { moneyFormat } from '../utility'

function handleDate (date: string) {
    const result = helpers.splitDateTime(date)
    return `${result.slashedDate}, ${result.completeTime}`
}

export const borrowerListColumns = [
    {
        name: 'BORROWER',
        key: 'borrower',
        width: '20',
        jsx: (item: any) => <AppText width='20' textSize='1.2' className='table-text' >{item.firstName} {item.lastName}</AppText>
    },
    {
        name: 'AMOUNT',
        key: 'amountBorrowed',
        textAlign: 'center',
        width: '15',
        jsx: (item: any) => <AppText textSize='1.2' align='center' width='15' className='table-text'>₦{moneyFormat(item.amountBorrowed)}</AppText>
    },
    {
        name: 'TOTAL REPAYABLE AMOUNT',
        key: 'totalAmountToBeRepaid',
        textAlign: 'center',
        width: '15',
        jsx: (item: any) => <AppText textSize='1.2'  align='center' width='15' className='table-text'>₦{moneyFormat(item.totalAmountToBeRepaid)}</AppText>
    },
    {
        name: 'MONTHLY AMOUNT REPAYABLE',
        key: 'amountToBePaidPerTenor',
        textAlign: 'center',
        width: '20',
        jsx: (item: any) => <AppText textSize='1.2' width='20'  align='center' className='table-text'>₦{moneyFormat(item.amountToBePaidPerTenor)}</AppText>
    },
    {
        name: 'REPAYMENTS',
        key: 'numberOfRepayments',
        textAlign: 'center',
        width: '15'
    },
    {
        name: 'STATUS',
        key: 'repaymentStatus',
        jsx: (item: any) => 
            <GridContainer 
                width='auto' sizeUnit='' height='2.4' bgColor={item?.repaymentStatus === 'Defaulted' ? '#FFE6E4' : '#DEFFEE'} 
                radius='2.1' leftPadding='1' rightPadding='1'
            >
                <AppText textSize='1.2' fontWeight='600' color={item?.repaymentStatus === 'Defaulted' ? '#F16063' : '#4AAE8C'}>
                    {item?.repaymentStatus}
                </AppText>
            </GridContainer>
    },
]

export const borrowerListData = [
    {
        borrower: 'John Doe',
        amount: '₦30,000',
        totalRepayment: '₦33,000',
        monthlyRepayment: '₦11,000',
        repayments: '1/3',
        status: 'On track'
    },
    {
        borrower: 'Newton Raphson',
        amount: '₦40,000',
        totalRepayment: '₦43,000',
        monthlyRepayment: '₦11,000',
        repayments: '1/3',
        status: 'On track'
    },
    {
        borrower: 'Habeeb Iropo',
        amount: '₦50,000',
        totalRepayment: '₦53,000',
        monthlyRepayment: '₦11,000',
        repayments: '2/3',
        status: 'On track'
    },
    {
        borrower: 'Hrithik Roshan',
        amount: '₦20,000',
        totalRepayment: '₦33,000',
        monthlyRepayment: '₦11,000',
        repayments: '1/3',
        status: 'Defaulted'
    },
    {
        borrower: 'Cristiano Ronaldo',
        amount: '₦85,000',
        totalRepayment: '₦100,000',
        monthlyRepayment: '₦20,000',
        repayments: '1/3',
        status: 'On track'
    },
    {
        borrower: 'Leo Messi',
        amount: '₦110,000',
        totalRepayment: '₦132,000',
        monthlyRepayment: '₦11,000',
        repayments: '2/3',
        status: 'On track'
    },
    {
        borrower: 'Kylian Mbappe',
        amount: '₦52,500',
        totalRepayment: '₦70,000',
        monthlyRepayment: '₦20,000',
        repayments: '3/3',
        status: 'On track'
    }
]

// ================================== REPAYMENTS =========================================

export const repaymentsColumns = [
    {
        name: 'REPAYMENTS',
        key: 'id',
        width: '15'
    },
    {
        name: 'SCHEDULED PAYMENT',
        key: 'scheduledPayment',
        textAlign: 'center',
        width: '20',
        jsx: (item: any) => <AppText width='20' align='center' textSize='1.2' className='table-text' >₦{moneyFormat(item.scheduledPayment)}</AppText>
    },
    {
        name: 'AMOUNT PAID',
        key: 'amountPaid',
        textAlign: 'center',
        width: '20',
        jsx: (item: any) => <AppText width='20' align='center' textSize='1.2' className='table-text' >₦{moneyFormat(item.amountPaid)}</AppText>
    },
    {
        name: 'TOTAL REPAYABLE AMOUNT',
        key: 'principalPayment',
        textAlign: 'center',
        width: '20',
        jsx: (item: any) => <AppText width='20' align='center' textSize='1.2' className='table-text' >₦{moneyFormat(item.principalPayment)}</AppText>
    },
    {
        name: 'PAYMENT DATE',
        key: 'paymentDate',
        textAlign: 'center',
        width: '20',
        jsx: (item: any) => <AppText width='20' align='center' textSize='1.2' className='table-text' >{handleDate(item.paymentDate)}</AppText>
    },
    {
        name: 'STATUS',
        key: 'status',
        jsx: (item: any) => 
            <GridContainer 
                width='auto' sizeUnit='' height='2.4' bgColor={!item?.paid ? '#FFE6E4' : '#DEFFEE'} 
                radius='2.1' leftPadding='1' rightPadding='1'
            >
                <AppText textSize='1.2' fontWeight='600' color={!item?.paid ? '#F16063' : '#4AAE8C'}>
                    {item?.paid ? 'Paid' : 'Not Paid'}
                </AppText>
            </GridContainer>
    },
]

export const repaymentsData = [
    {   
        repayments: '1/3',
        amount: '₦30,000',
        totalRepayment: '₦33,000',
        monthlyRepayment: '₦11,000',
        status: 'Defaulted'
    },
    {
        repayments: '1/3',
        amount: '₦40,000',
        totalRepayment: '₦43,000',
        monthlyRepayment: '₦11,000',
        status: 'On track'
    },
    {
        repayments: '2/3',
        amount: '₦50,000',
        totalRepayment: '₦53,000',
        monthlyRepayment: '₦11,000',
        status: 'On trackuyysyuwsuy'
    },
]

// ================================== TRANSACTIONS =================================

export const transactionColumns = [
    {
        name: 'TRANSACTION',
        key: 'transactionType',
        width: '12'
    },
    {
        name: 'DATE',
        key: 'dateAdded',
        width: '10',
        jsx: (item: any) => 
            <AppText 
                width='10' textSize="1.2" 
                className='table-text'
            >
                {helpers.splitDateTime(item.dateAdded)?.date},
            </AppText>
    },
    {
        name: 'TIME',
        key: 'dateAdded',
        width: '10',
        jsx: (item: any) => 
            <AppText 
                width='10' textSize="1.2" 
                className='table-text'
            >
                {helpers.splitDateTime(item.dateAdded)?.time} {helpers.splitDateTime(item.dateAdded)?.timeEnv}
            </AppText>
    },
    {
        name: 'DESCRIPTION',
        key: 'description',
        width: '30'
    },
    {
        name: 'AMOUNT',
        key: 'amount',
        textAlign: 'center',
        width: '15'
    },
    {
        name: 'TYPE',
        key: 'operation',
        textAlign: 'center',
        width: '10',
        jsx: (item: any) => 
            <AppText 
                width='10' textSize="1.2" 
                align='center' color={item.operation === 'Debit' ? '#F16063' : '#4AAE8C'}
                className='table-text'
            >
                {item?.operation}
            </AppText>
    },
    {
        name: 'STATUS',
        key: 'status',
        jsx: (item: any) => 
            <GridContainer 
                width='9' height='2.4' bgColor={item?.status != 'success' ? '#FFE6E4' : '#DEFFEE'} 
                radius='2.1' leftPadding='1' rightPadding='1'
            >
                <AppText textSize='1.2' fontWeight='600' color={item?.status != 'success' ? '#F16063' : '#4AAE8C'}>
                    {item?.status}
                </AppText>
            </GridContainer>
    },
]

export const transactionData = [
    {
        transactionType: 'Loan Disbursed',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Loan disbursed from portfolio balance',
        amount: '₦50,000',
        operation: 'Debit',
        status: 'failed'
    },
    {
        transactionType: 'Funds Withdrawal',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Funds withdrawn to bank account.',
        amount: '₦50,000',
        operation: 'Debit',
        status: 'success'
    },
    {
        transactionType: 'Wallet topup',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Wallet topup using debit card',
        amount: '₦50,000',
        operation: 'Credit',
        status: 'success'
    },
    {
        transactionType: 'Portfolio created',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Funds locked from portfolio creation',
        amount: '₦350,000',
        operation: 'Debit',
        status: 'success'
    },
    {
        transactionType: 'Loan repayment',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Auto debit for loan repayment',
        amount: '₦350,000',
        operation: 'Debit',
        status: 'failed'
    },
    {
        transactionType: 'Wallet topup',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Wallet topup using debit card',
        amount: '₦750,000',
        operation: 'Credit',
        status: 'success'
    },
    {
        transactionType: 'Portfolio created',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Funds locked from portfolio creation',
        amount: '₦750,000',
        operation: 'Debit',
        status: 'success'
    },
    {
        transactionType: 'Loan repayment',
        dateAdded: '2022-08-13T10:27:52.409908',
        description: 'Auto debit for loan repayment',
        amount: '₦35,000',
        operation: 'Debit',
        status: 'failed'
    }
]

// =================================== CONVERSATIONS ====================================

export const chatColumns = [
    {
        name: 'TITLE',
        key: 'title',
        width: '40',
        jsx: (item: any) => (
            <FlexRow width='40' style={{whiteSpace: 'normal'}}>
                <GridContainer 
                    width='4.5' height='3.8' radius='0.3' bgColor='#4C6FFF' rightMargin='1'
                >
                    <AppText textSize='1.7' fontWeight='700' color='#ffffff'>M</AppText>
                </GridContainer>
                <CustomContainer>
                    <AppText textSize='1.2' fontWeight='600' color='#101225'>
                        {item?.title}
                        <AppSpan textSize='1.2' color='#6F7C87' leftMargin='1'>#6493</AppSpan>
                    </AppText>
                    <AppText>
                        <AppSpan color="#9AA3AB" rightMargin='0.6' textSize='1.2'><BsChatLeft/></AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB' rightMargin='0.8'>Ridwan</AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB'>Created 2 hours ago</AppSpan>
                        <AppSpan size='0.4' rightMargin='0.5' leftMargin='0.5' 
                            style={{display: 'inline-block', height: '0.4rem', width: '0.4rem', backgroundColor: '#9AA3AB', borderRadius: '50%'}} 
                        />
                        <AppSpan textSize='1' color='#9AA3AB'>Response due in 2 hours</AppSpan>
                    </AppText>
                </CustomContainer>
            </FlexRow>
        )
    },
    {
        name: 'STATUS',
        key: 'status',
        width: '15',
        jsx: (item: any) => 
            <CustomContainer width='15'>
                <GridContainer 
                    width='9' height='2.4' bgColor={item?.status === 'Open' ? '#E1E8FF' : item?.status === 'Unresolved' ? '#FFE6E4' : '#DEFFEE'} 
                    radius='2.1' leftPadding='1' rightPadding='1'
                >
                    <AppText textSize='1.2' fontWeight='600' color={item?.status === 'Open' ? '#4C6FFF' : item?.status === 'Unresolved' ? '#F16063' : '#4AAE8C'}>
                        {item?.status}
                    </AppText>
                </GridContainer>
            </CustomContainer>
    },
    {
        name: 'DEPARTMENT',
        key: 'department',
        width: '13'
    },
    {
        name: 'PRIORITY',
        key: 'priority',
        width: '17',
        jsx: (item: any) => (
            <CustomContainer width='17'>
                <FlexRow width='11' justifyContent='space-between'>
                    <FlexRow>
                        <CustomContainer 
                            bgColor={item?.priority === 'Low' ? '#4AAE8C' : item?.priority === 'Medium' ? '#F7936F' : '#F16063'} 
                            radius="0.1" height='1.2' width='1.2' rightMargin='1'
                        />
                        <AppText textSize='1.2'>{item?.priority}</AppText>
                    </FlexRow>
                    <HiOutlineChevronDown style={{color: '#4A5568', marginLeft: '2rem', fontSize: '2rem'}} />
                </FlexRow>
            </CustomContainer>
        )
    },
    {
        name: 'ASSIGNED TO',
        key: 'assignedTo',
        width: '15'
    }
]

export const chatData = [
    {
        title: 'THW - Password Reset',
        status: 'Open',
        department: 'support',
        priority: 'Low',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Unresolved',
        department: 'Tech',
        priority: 'Medium',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        priority: 'Low',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        priority: 'High',
        assignedTo: 'Olaniyi Jibola'
    },
]


export const callColumns = [
    {
        name: 'TITLE',
        key: 'title',
        width: '40',
        jsx: (item: any) => (
            <FlexRow width='40' style={{whiteSpace: 'normal'}}>
                <GridContainer 
                    width='4.5' height='3.8' radius='0.3' bgColor='#4C6FFF' rightMargin='1'
                >
                    <AppText textSize='1.7' fontWeight='700' color='#ffffff'>M</AppText>
                </GridContainer>
                <CustomContainer>
                    <AppText textSize='1.2' fontWeight='600' color='#101225'>
                        {item?.title}
                        <AppSpan textSize='1.2' color='#6F7C87' leftMargin='1'>#6493</AppSpan>
                    </AppText>
                    <AppText>
                        <AppSpan color="#9AA3AB" rightMargin='0.6' textSize='1.2'><BsChatLeft/></AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB' rightMargin='0.8'>Ridwan</AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB'>Created 2 hours ago</AppSpan>
                        <AppSpan size='0.4' rightMargin='0.5' leftMargin='0.5' 
                            style={{display: 'inline-block', height: '0.4rem', width: '0.4rem', backgroundColor: '#9AA3AB', borderRadius: '50%'}} 
                        />
                        <AppSpan textSize='1' color='#9AA3AB'>Response due in 2 hours</AppSpan>
                    </AppText>
                </CustomContainer>
            </FlexRow>
        )
    },
    {
        name: 'STATUS',
        key: 'status',
        width: '15',
        jsx: (item: any) => 
            <CustomContainer width='15'>
                <GridContainer 
                    width='9' height='2.4' bgColor={item?.status === 'Open' ? '#E1E8FF' : item?.status === 'Unresolved' ? '#FFE6E4' : '#DEFFEE'} 
                    radius='2.1' leftPadding='1' rightPadding='1'
                >
                    <AppText textSize='1.2' fontWeight='600' color={item?.status === 'Open' ? '#4C6FFF' : item?.status === 'Unresolved' ? '#F16063' : '#4AAE8C'}>
                        {item?.status}
                    </AppText>
                </GridContainer>
            </CustomContainer>
    },
    {
        name: 'DURATION',
        key: 'duration',
        width: '15'
    },
    {
        name: 'DEPARTMENT',
        key: 'department',
        width: '13'
    },
    {
        name: 'ASSIGNED TO',
        key: 'assignedTo',
        width: '12'
    },
    {
        name: ' ',
        key: 'play',
        width: '10',
        jsx: () => (
            <CustomContainer width='10'>
                <Circle size='2.5' borderColor='#4C6FFF'>
                    <IoPlayOutline style={{color: '#4C6FFF', fontSize: '1.6rem'}} />
                </Circle>
            </CustomContainer>
        )
    }
]

export const callData = [
    {
        title: 'THW - Password Reset',
        status: 'Open',
        department: 'support',
        duration: '23:14 mins',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Unresolved',
        department: 'Tech',
        duration: '23:14 mins',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        duration: '23:14 mins',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        duration: '23:14 mins',
        assignedTo: 'Olaniyi Jibola'
    },
]

export const scheduledCallColumns = [
    {
        name: 'TITLE',
        key: 'title',
        width: '40',
        jsx: (item: any) => (
            <FlexRow width='40' style={{whiteSpace: 'normal'}}>
                <GridContainer 
                    width='4.5' height='3.8' radius='0.3' bgColor='#4C6FFF' rightMargin='1'
                >
                    <AppText textSize='1.7' fontWeight='700' color='#ffffff'>M</AppText>
                </GridContainer>
                <CustomContainer>
                    <AppText textSize='1.2' fontWeight='600' color='#101225'>
                        {item?.title}
                        <AppSpan textSize='1.2' color='#6F7C87' leftMargin='1'>#6493</AppSpan>
                    </AppText>
                    <AppText>
                        <AppSpan color="#9AA3AB" rightMargin='0.6' textSize='1.2'><BsChatLeft/></AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB' rightMargin='0.8'>Ridwan</AppSpan>
                        <AppSpan textSize='1' color='#9AA3AB'>Created 2 hours ago</AppSpan>
                        <AppSpan size='0.4' rightMargin='0.5' leftMargin='0.5' 
                            style={{display: 'inline-block', height: '0.4rem', width: '0.4rem', backgroundColor: '#9AA3AB', borderRadius: '50%'}} 
                        />
                        <AppSpan textSize='1' color='#9AA3AB'>Response due in 2 hours</AppSpan>
                    </AppText>
                </CustomContainer>
            </FlexRow>
        )
    },
    {
        name: 'STATUS',
        key: 'status',
        width: '15',
        jsx: (item: any) => 
            <CustomContainer width='15'>
                <GridContainer 
                    width='9' height='2.4' bgColor={item?.status === 'Open' ? '#E1E8FF' : item?.status === 'Unresolved' ? '#FFE6E4' : '#DEFFEE'} 
                    radius='2.1' leftPadding='1' rightPadding='1'
                >
                    <AppText textSize='1.2' fontWeight='600' color={item?.status === 'Open' ? '#4C6FFF' : item?.status === 'Unresolved' ? '#F16063' : '#4AAE8C'}>
                        {item?.status}
                    </AppText>
                </GridContainer>
            </CustomContainer>
    },
    {
        name: 'TIME',
        key: 'time',
        width: '15'
    },
    {
        name: 'DEPARTMENT',
        key: 'department',
        width: '13'
    },
    {
        name: 'ASSIGNED TO',
        key: 'assignedTo',
        width: '12'
    },
    {
        name: ' ',
        key: 'play',
        width: '10',
        jsx: () => (
            <CustomContainer width='10'>
                <Circle size='2.8' borderColor='#4AAE8C'>
                    <BsTelephone style={{color: '#4AAE8C', fontSize: '1.6rem'}} />
                </Circle>
            </CustomContainer>
        )
    }
]

export const scheduledCallData = [
    {
        title: 'THW - Password Reset',
        status: 'Open',
        department: 'support',
        time: '2.30pm - 3pm',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Unresolved',
        department: 'Tech',
        time: '2.30pm - 3pm',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        time: '2.30pm - 3pm',
        assignedTo: 'Olaniyi Jibola'
    },
    {
        title: 'THW - Password Reset',
        status: 'Closed',
        department: 'support',
        time: '2.30pm - 3pm',
        assignedTo: 'Olaniyi Jibola'
    },
]

// ===================================== LOGIN HISTORY =================================

export const loginHistoryColumns = [
    {
        name: <p className="table-column-title">DATE</p>,
        selector:(row: any) => <AppText>{row.date ? helpers.splitDateTime(row.date).slashedDate : ''}</AppText>,
    },
    {
        name: <p className="table-column-title">IP ADDRESS</p>,
        selector:(row: any) => <AppText>{row.ipAddress}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">CHANNEL</p>,
        selector:(row: any) => <AppText>{row.channel}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">LAST LOGIN</p>,
        selector:(row: any) => <AppText>{row.lastLogin}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">LONGITUDE</p>,
        selector:(row: any) => <AppText>{row.longitude}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">LATITUDE</p>,
        selector:(row: any) => <AppText>{row.latitude}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">SESSION</p>,
        selector:(row: any) => <AppText>{row.session}</AppText>,
    },
    {
        name: <p className="table-column-title">STATE</p>,
        selector:(row: any) => <AppText>{row.state}</AppText>,
    },
    {
        name: <p className="table-column-title">LOGIN TYPE</p>,
        selector:(row: any) => <AppText>{row.loginType}</AppText>,
        minWidth: '15rem'
    }
]

export const loginHistoryData = [
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Password'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Web app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    },
    {
        date: '29/2/22',
        ipAddress: '103.234.101.93',
        channel: 'Mobile app',
        lastLogin: '28/11/2022, 2:58pm',
        longitude: '9.0399762',
        latitude: '5.0394362',
        session: '40 mins',
        state: 'Lagos',
        loginType: 'Biometric'
    }
]

// ====================================== TEAM AUDIT ========================================

export const teamAuditColumns = [
    {
        name: <p className="table-column-title">DATE</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.date}</AppText>,
    },
    {
        name: <p className="table-column-title">TIME</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.time}</AppText>,
        minWidth: '10rem'
    },
    {
        name: <p className="table-column-title">AGENT NAME</p>,
        selector:(row: any) => (
            <CustomContainer topPadding='0.5' bottomPadding='0.5'>
                <AppText textSize='1.2' fontWeight='600' bottomMargin='0.5'>{row.agentName}</AppText>
                <AppSpan color='#718096' textSize='1.2'>{row.agentEmail}</AppSpan>
            </CustomContainer>
        ),
        minWidth: '20rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">STATUS</p>,
        selector:(row: any) => <AppText textSize='1.2' color={row.status === 'Online' ? '#4AAE8C' : '#425466'}>{row.status}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">EVENT</p>,
        selector:(row: any) => (
            <CustomContainer>
                <AppText textSize='1.2' fontWeight='600' bottomMargin='0.5'>{row.event}</AppText>
                <AppSpan color='#718096' textSize='1.2'>{row.eventText}</AppSpan>
            </CustomContainer>
        ),
        minWidth: '22rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">IP ADDRESS</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.ipAddress}</AppText>,
        minWidth: '15rem'
    }
]

export const teamAuditData = [
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Online',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Last seen 2:50PM',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Online',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Last seen 2:50PM',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Online',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Last seen 2:50PM',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
    {
        date: '29/2/22',
        time: '2:50PM',
        agentName: 'Ridwan Kolawole',
        agentEmail: 'ridwankolawole@gmail.com',
        status: 'Online',
        event: 'Ticket closure',
        eventText: 'Ticket closed on James Johnson',
        ipAddress: '103.234.101.93'
    },
]

// ====================================== DISPUTES AND REQUESTS =================================

export const disputeColumns = (onStatusChange: any) => [
    {
        name: <p className="table-column-title">CASE ID</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.caseId}</AppText>,
        minWidth: '10rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">DATE OPENED</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.dateOpenned ? helpers.splitDateTime(row.dateOpenned)?.slashedDate : ''}</AppText>,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">DESCRIPTION</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.description}</AppText>,
        minWidth: '25rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">OPENED BY</p>,
        selector:(row: any) => <AppText textSize='1.2' >{row.opennedBy}</AppText>,
        minWidth: '17rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">ASSIGNED TO</p>,
        selector:(row: any) => <AppText textSize='1.2' >{row.assignedTo}</AppText>,
        minWidth: '17rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">DEPARTMENT</p>,
        selector:(row: any) => <AppText textSize='1.2' >{row.department}</AppText>,
        minWidth: '17rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">PRIORITY</p>,
        selector:(row: any) => (
            <CustomContainer width='17'>
                <FlexRow width='11' justifyContent='space-between'>
                    <FlexRow>
                        <CustomContainer 
                            bgColor={row?.priority === 'Low' ? '#4AAE8C' : row?.priority === 'Medium' ? '#F7936F' : '#F16063'} 
                            radius="0.1" height='1.2' width='1.2' rightMargin='1'
                        />
                        <AppText textSize='1.2'>{row?.priority}</AppText>
                    </FlexRow>
                    <HiOutlineChevronDown style={{color: '#4A5568', marginLeft: '2rem', fontSize: '2rem'}} />
                </FlexRow>
            </CustomContainer>
        ),
        minWidth: '17rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">STATUS</p>,
        selector:(row: any) => (
            <GridContainer 
                height='2.4' bgColor={row?.status === 'Open' ? '#E1E8FF' : row?.status === 'Unresolved' ? '#FFE6E4' : '#DEFFEE'} 
                radius='2.1' leftPadding='1' rightPadding='1'
            >
                <AppText textSize='1.2' fontWeight='600' color={row?.status === 'Open' ? '#4C6FFF' : row?.status === 'Unresolved' ? '#F16063' : '#4AAE8C'}>
                    {row?.status}
                </AppText>
            </GridContainer>
        ),
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">SLA</p>,
        selector:(row: any) => <AppText textSize='1.2' >{row.sla}</AppText>,
        minWidth: '8rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">DATE CLOSED</p>,
        selector:(row: any) => <AppText textSize='1.2'>{row.dateClosed ? helpers.splitDateTime(row.dateClosed)?.slashedDate : ''}</AppText>,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">ACTION</p>,
        selector:(row: any) => (
            <CustomContainer>
                <select 
                    style={{position: 'absolute', top: '0', left: '0', zIndex: '3', opacity: '0'}}
                    onChange={(e) => onStatusChange(row.id, e.target.value)}
                >
                    <option value='' hidden>Actions</option>
                    <option value={JSON.stringify(row)}>View</option>
                    <option value='Resolved' disabled={row.status === 'Resolved'}>Mark as resolved</option>
                    <option value='Unresolved' disabled={row.status === 'Unresolved'}>Unmarked as resolved</option>
                </select>
                <AppSpan textSize='1.6'>
                    <BsThreeDotsVertical/>
                </AppSpan>
            </CustomContainer>
        ),
        minWidth: '10rem'
    }
]

export const allDisputeData = [
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Open',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'High',
        status: 'Unresolved',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Medium',
        status: 'Open',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'High',
        status: 'Unresolved',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Medium',
        status: 'Open',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Open',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'High',
        status: 'Unresolved',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpenned: '29/10/2022',
        description: 'DIS - Password Reset',
        opennedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Medium',
        status: 'Open',
        sla: '24 hrs',
        dateClosed: '30/10/2022'
    },
]

export const disputeData = [
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Open',
        SLA: '24 hrs',
        dateClosed: '--'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'High',
        status: 'Unresolved',
        SLA: '24 hrs',
        dateClosed: '--'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Medium',
        status: 'Open',
        SLA: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        SLA: '24 hrs',
        dateClosed: '--'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'High',
        status: 'Unresolved',
        SLA: '24 hrs',
        dateClosed: '--'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Medium',
        status: 'Open',
        SLA: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        SLA: '24 hrs',
        dateClosed: '30/10/2022'
    },
]

export const requestData = [
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        SLA: '24 hrs',
        dateClosed: '30/10/2022'
    },
    {
        caseId: 'CL001',
        dateOpened: '29/10/2022',
        description: 'DIS - Password Reset',
        openedBy: 'Ridwan Kolawole',
        assignedTo: 'Chijindi Amadi',
        department: 'Tech',
        priority: 'Low',
        status: 'Closed',
        SLA: '24 hrs',
        dateClosed: '30/10/2022'
    },
]


// ===================== ALL CUSTOMERS =================

export const customersColumns = [
    {
        name: <p className="table-column-title">FIRST NAME</p>,
        selector:(row: any) => <AppText>{row.firstName}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">LAST NAME</p>,
        selector:(row: any) => <AppText>{row.lastName}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">CUSTOMER ID</p>,
        selector:(row: any) => <AppText>{row.customerId}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">EMAIL</p>,
        selector:(row: any) => <AppText>{row.email}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">PHONE NUMBER</p>,
        selector:(row: any) => <AppText>{row.phoneNumber}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">GENDER</p>,
        selector:(row: any) => <AppText>{row.gender}</AppText>
    },
    {
        name: <p className="table-column-title">ADDRESS VERIFICATION</p>,
        selector:(row: any) => <AppText>{row.isAddressVerified ? 'Verified' : 'Not Verified'}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">DATE JOINED</p>,
        selector:(row: any) => <AppText>{row.dateJoined}</AppText>,
        minWidth: '25rem'
    }
]

// ===================== ALL PORTFOLIOS =================

export const portfoliosColumns = [
    {
        name: <p className="table-column-title">LOAN TYPE</p>,
        selector:(row: any) => <AppText>{row.loanTypeName}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">AMOUNT</p>,
        selector:(row: any) => <AppText>₦{moneyFormat(row.amount)}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">AMOUNT PER PERSON</p>,
        selector:(row: any) => <AppText>₦{moneyFormat(row.amountPerPerson)}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">NO. OF BORROWERS</p>,
        selector:(row: any) => <AppText>{row.numberOfBorrowers}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">TENOR</p>,
        selector:(row: any) => <AppText>{row.tenor} {row.tenorType}(s)</AppText>,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">INTEREST RATE</p>,
        selector:(row: any) => <AppText>{row.interest}(%)</AppText>
    },
    {
        name: <p className="table-column-title">REPAYMENT</p>,
        selector:(row: any) => <AppText>{row.rateName === 'FLAT' ? 'One-Off' : 'Installment'}</AppText>,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">PORTFOLIO STATUS</p>,
        selector:(row: any) => <AppText>{row.completed ? 'Ended' : row.taken ? 'Running' : 'Open'}</AppText>,
        minWidth: '25rem'
    }
]

// ===================== ALL LOANS =================

export const loanColumns = [
    {
        name: <p className="table-column-title">LOAN TYPE</p>,
        selector:(row: any) => <AppText>{row.loanRequest?.loanOffer?.loanTypeName}</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">AMOUNT</p>,
        selector:(row: any) => <AppText>₦{moneyFormat(row.loanRequest?.loanOffer?.amountPerPerson)}</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">TENOR</p>,
        selector:(row: any) => <AppText>{row.loanRequest?.loanOffer?.tenor} {row.loanRequest?.loanOffer?.tenorType}(s)</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">INTEREST RATE</p>,
        selector:(row: any) => <AppText>{row.loanRequest?.loanOffer?.interest}%</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">REPAYMENT</p>,
        selector:(row: any) => <AppText>{row.loanRequest?.loanOffer?.rateName === 'FLAT' ? 'One-Off' : 'Installment'}</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">PORTFOLIO STATUS</p>,
        selector:(row: any) => <AppText>{row.loanRequest?.completed ? 'Repaid' : row.loanRequest?.confirmed ? 'Running' : 'Open'}</AppText>,
        wrap: true
    }
]


// =========================== ALL TRANSACTIONS ==================

export const allTransactionsColumns = [
    {
        name: <p className="table-column-title">TRANSACTION TYPE</p>,
        selector:(row: any) => <AppText>{row.transactionType}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">DATE</p>,
        selector:(row: any) => <AppText>{row.dateAdded ? helpers.splitDateTime(row.dateAdded)?.date : null}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">TIME</p>,
        selector:(row: any) => <AppText>{row.dateAdded ? `${helpers.splitDateTime(row.dateAdded)?.time} ${helpers.splitDateTime(row.dateAdded)?.timeEnv}` : null}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">DESCRIPTION</p>,
        selector:(row: any) => <AppText>{row.description}</AppText>,
        wrap: true,
        minWidth: '25rem'
    },
    {
        name: <p className="table-column-title">AMOUNT</p>,
        selector:(row: any) => <AppText>₦{moneyFormat(row.amount)}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">TYPE</p>,
        selector:(row: any) => <AppText>{row.operation}</AppText>,
        wrap: true
    },
    {
        name: <p className="table-column-title">EMAIL</p>,
        selector:(row: any) => <AppText>{row.emailAddress}</AppText>,
        minWidth: '25rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">CUSTOMER ID</p>,
        selector:(row: any) => <AppText>{row?.customerId}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">STATUS</p>,
        selector:(row: any) => <AppText>{row.status}</AppText>,
        wrap: true
    }
]

// ===================== ERROR LOGS =================

export const errorLogsColumns = [
    {
        name: <p className="table-column-title">ERROR ID</p>,
        selector:(row: any) => <AppText>{row.id}</AppText>,
        wrap: true,
        minWidth: '25rem'
    },
    {
        name: <p className="table-column-title">ERROR MESSAGE</p>,
        selector:(row: any) => <AppText>{row.errorMessage}</AppText>,
        minWidth: '35rem',
        wrap: true
    },
    {
        name: <p className="table-column-title">SERVICE</p>,
        selector:(row: any) => <AppText>{row.originatingService}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">ENDPOINT / METHOD</p>,
        selector:(row: any) => <AppText>{row.endpointOrMethod}</AppText>,
        wrap: true,
        minWidth: '18rem'
    },
    {
        name: <p className="table-column-title">UNIQUE IDENTIFIER</p>,
        selector:(row: any) => <AppText>{row.uniqueIdentifier}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">DATE</p>,
        selector:(row: any) => <AppText>{row.timeStamp ? handleDate(row.timeStamp) : null}</AppText>,
        wrap: true,
        minWidth: '15rem'
    }
]